<template>
  <div>
    <wb-notification
      icon="bds/checkmark-circle/16"
      mode="success"
      v-if="showCopyAlert"
      :style="copyAlertStyle"
      hide-dismiss-button
    >
      <wb-notification-content>
        {{ $t('summary.copyNotification.label') }}
      </wb-notification-content>
    </wb-notification>
    <p class="otb-summary__dealer-date-place" :class="dateAndPlaceClass">
      {{ dateAndPlace }}
    </p>
    <div
      class="otb-summary__dealer-address wb-type-copy"
      v-if="dealerAddressVisible"
    >
      <div v-if="!isTestDriveFromHomeEnabled">
        <wb-icon
          name="bds/location-dealer/24"
          class="otb-summary__dealer-icon"
        ></wb-icon>
        {{ dealerInformation.address.computedAddress }}
      </div>
      <div v-else>
        <div :class="{ 'otb-summary__dealer__tdfh': !isMobile }">
          <wb-icon
            name="bds/location-dealer/24"
            class="otb-summary__dealer-icon"
          ></wb-icon>
          <p class="wb-type-copy-strong">
            {{ dealerInformation.computedName }}
          </p>
        </div>
        <p class="wb-type-copy-secondary">
          {{ dealerInformation.address.computedAddress }}
        </p>
      </div>
    </div>
    <div
      class="otb-summary__dealer-contacts wb-type-copy"
      v-if="dealerContactsVisible"
    >
      <span
        class="otb-summary__dealer-field wb-margin-bottom-xxs"
        v-if="dealerInformation.contacts.phone"
      >
        <wb-icon name="bds/call/24" class="otb-summary__dealer-icon"></wb-icon>
        {{ dealerInformation.contacts.phone }}
      </span>
      <span
        class="otb-summary__dealer-field"
        v-if="dealerInformation.contacts.email"
      >
        <wb-icon name="bds/mail/24" class="otb-summary__dealer-icon"></wb-icon>
        <a
          :href="mailto(dealerInformation.contacts.email)"
          class="otb-summary__dealer-span--email"
          >{{ dealerInformation.contacts.email }}</a
        >
        <span
          class="otb-summary__dealer-span"
          @click="copy(dealerInformation.contacts.email)"
        >
          <wb-icon
            name="copy-clipboard/24"
            class="otb-summary__dealer-icon--copy"
          ></wb-icon>
          {{ $t('shared.copyIcon.label') }}
        </span>
      </span>
    </div>
  </div>
</template>
<script lang="ts">
import { computed, defineComponent, ref } from 'vue';

import { useStore } from '../../../../composables/store.composable';
import { useMediaQuery } from '../../../../composables/media-query.composable';

export default defineComponent({
  name: 'otb-summary-dealer-info',
  props: {
    dateAndPlace: String,
    dealerInformation: {
      type: Object,
      required: true,
    },
  },
  setup(props) {
    const { getter } = useStore();
    const { isMobile } = useMediaQuery();

    const showCopyAlert = ref(false);
    const copyAlertStyle = ref({});

    const isTestDriveFromHomeEnabled = computed(
      () => getter?.isTestDriveFromHomeEnabled
    );

    const dealerAddressVisible = computed((): boolean => {
      return (
        props.dealerInformation &&
        props.dealerInformation.address &&
        props.dealerInformation.address.computedAddress
      );
    });

    const dealerContactsVisible = computed((): boolean => {
      return (
        props.dealerInformation &&
        props.dealerInformation.contacts &&
        (props.dealerInformation.contacts.phone ||
          props.dealerInformation.contacts.email)
      );
    });

    const dateAndPlaceClass = computed(() => {
      return isMobile.value ? 'wb-type-heading-xs' : 'wb-type-heading-s';
    });

    const copy = (textValue: string) => {
      navigator.clipboard.writeText(textValue);
      showCopyAlert.value = true;

      setTimeout((): void => {
        copyAlertStyle.value = {
          position: 'fixed !important',
          top: '1rem',
          left: '3%',
          margin: 0,
          width: '94%',
        };
      }, 1);

      setTimeout((): void => {
        showCopyAlert.value = false;
        copyAlertStyle.value = {};
      }, 5000);
    };

    const mailto = (textValue: string) => {
      return `mailto:${textValue}`;
    };

    return {
      isTestDriveFromHomeEnabled,
      isMobile,
      dateAndPlaceClass,
      dealerAddressVisible,
      dealerContactsVisible,
      copy,
      showCopyAlert,
      copyAlertStyle,
      mailto,
    };
  },
});
</script>
<style lang="scss" src="./summary-dealer-info.scss"></style>
